import { useState } from 'react'

import SubmenuHeader from 'src/components/menu/SubmenuHeader'
import { MainLayout } from 'src/components/layouts/MainLayout'
import MenuWrapper from 'src/components/menu/MenuWrapper'
import ModalCommon from 'src/components/common/ModalCommon'
import { deleteUserAccount } from 'src/services/delete/deleteUserAccount'
import { NEW_USER_PATHS } from 'src/routes/newUser'

const WITHDRAWAL_NOTICES = [
  '退会後、退会前のデータをご利用いただくことはできません。',
  '退会後、現在のアカウントを復元することはできません。',
  '退会する際、所持ダイヤやアイテムなどに関しての返金対応などは行っておりません。',
  'アカウント情報は完全にリセットされます。退会後、新規アカウントにて再度ご遊戯を行い「昔○○というアカウント名で遊んでたよ」などの前アカウントに関する情報をトークには対応できませんので予めご了承ください。'
]

const WithdrawalPage = () => {
  const [isChecked, setIsChecked] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleWithdraw = async () => {
    try {
      await deleteUserAccount()
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = NEW_USER_PATHS.RegistUserPage
    } catch {
      setIsModalOpen(false)
    }
  }

  const modalButtons = [
    {
      label: 'キャンセル',
      onClick: () => setIsModalOpen(false),
      type: 'close'
    },
    {
      label: '退会する',
      onClick: handleWithdraw
    }
  ]

  return (
    <MainLayout className="bg-menu-bg" active="menu" classNameHeader="">
      <MenuWrapper className="flex items-center flex-col" overflow={true}>
        <SubmenuHeader title="退会時注意事項" />
        <div
          className="overflow-y-auto hidden-scroll px-4 pb-4"
          style={{ height: 'calc(100dvh - 240px)' }}
        >
          <div className="bg-white rounded-b-lg px-2 py-6">
            <div className="mt-6 space-y-1 text-left">
              {WITHDRAWAL_NOTICES.map((notice, index) => (
                <div key={index} className="flex gap-1">
                  <span className="text-xs text-bubblegum-pink font-bold shrink-0">
                    {`${String.fromCharCode(9312 + index)}`}
                  </span>
                  <p className="text-xs font-semibold leading-relaxed text-bubblegum-pink">
                    {notice}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col items-center gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="w-4 h-4 accent-candy-pink"
                />
                <span className="text-xs font-semibold text-bubblegum-pink">
                  退会時注意事項を確認しました
                </span>
              </label>

              <button
                disabled={!isChecked}
                onClick={() => setIsModalOpen(true)}
                className={`px-12 py-3 rounded-full text-sm font-bold border-2 transition-colors ${
                  isChecked
                    ? 'border-candy-pink text-candy-pink bg-white'
                    : 'border-gray-300 text-gray-300 bg-white cursor-not-allowed'
                }`}
              >
                退会する
              </button>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <ModalCommon
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="確認"
            buttons={modalButtons}
            theme="pink"
          >
            <div className="flex items-center justify-center font-inter font-bold bg-white px-2 py-8 text-candy-pink">
              本当に退会しますか？
            </div>
          </ModalCommon>
        )}
      </MenuWrapper>
    </MainLayout>
  )
}

export default WithdrawalPage
